// =====================================
//
//   兌換活動填寫資訊 Modal
//   Author: Gray
//   createtime: 2016 / 07 / 06
//   updatetime: 2016 / 07 / 06
//
// =====================================

window.InifECApp.directive('activityApply', ['$rootScope', '$stateParams', '$timeout', '$ngModal', 'UserService', 'ActivityService', '$state',
    function($rootScope, $stateParams, $timeout, $ngModal, UserService, ActivityService, $state) {

        var _dir = {};

        var controller = ['$scope', function($scope) {

            var checkUserInfo = function() {

                $scope.isUserNameEmpty = false;
                $scope.isUserMobilePhoneEmpty = false;
                $scope.isUserMobilePhoneError = false;
                $scope.isUserAddressEmpty = false;
                $scope.isUserPostalEmpty = false;
                $scope.isUserPostalError = false;
                $scope.isUserInvoiceError = false;
                $scope.isUserCompanyEmpty = false;
                $scope.isUserInvoiceEmpty = false;
                $scope.isParamsMissing = false;
                $scope.isParamsError = false;
                $scope.mobilephoneExistedError = false;
                $scope.isError = false;

                if(!$scope.user.name) {
                    $scope.isUserNameEmpty = true;
                }

                if(!$scope.user.mobilephone) {
                    $scope.isUserMobilePhoneEmpty = true;
                }

                if($scope.user.mobilephone && !isPhone($scope.user.mobilephone)) {
                    $scope.isUserMobilePhoneError = true;
                }

                if(!$scope.user.address) {
                    $scope.isUserAddressEmpty = true;
                }

                if(!$scope.user.postal) {
                    $scope.isUserPostalEmpty = true;
                }

                if($scope.user.postal && isNaN($scope.user.postal)) {
                    $scope.isUserPostalError = true;
                }

                if(!$scope.user.company) {
                    $scope.isUserCompanyEmpty = true;
                }

                if(!$scope.user.invoice) {
                    $scope.isUserInvoiceEmpty = true;
                }

                if($scope.user.invoice && isNaN($scope.user.invoice)) {
                    $scope.isUserInvoiceError = true;
                }

                if($scope.isUserNameEmpty || $scope.isUserMobilePhoneEmpty || $scope.isUserAddressEmpty || $scope.isUserPostalEmpty 
                    || $scope.isUserCompanyEmpty || $scope.isUserInvoiceEmpty || $scope.isUserInvoiceError) {
                    $scope.isParamsMissing = true;
                }

                if($scope.isUserMobilePhoneError || $scope.isUserPostalError) {
                    $scope.isParamsError = true;
                }

                $scope.userInfoIsChange = true;

                if($scope.user == $scope.oriuser 
                    || ($scope.user.name == $scope.oriuser.name 
                    && $scope.user.mobilephone == $scope.oriuser.mobilephone  
                    && $scope.user.postal == $scope.oriuser.postal 
                    && $scope.user.address == $scope.oriuser.address
                    && $scope.user.company == $scope.oriuser.company
                    && $scope.user.invoice == $scope.oriuser.invoice)) {
                    $scope.userInfoIsChange = false;
                }
            }

            var submit = function() {

                if($scope.isLoading) {
                    return;
                }

                checkUserInfo();

                if($scope.isParamsMissing || $scope.isParamsError) {
                    return;
                }

                $scope.isLoading = true;

                if($scope.userInfoIsChange) {

                    UserService.updateUserInfo($scope.user).then(function(result) {

                        if(result) {
                            $scope.userInfoIsChange = false;
                            $scope.oriuser = $scope.user;

                            addActivityLog($scope.user.email, $scope.user.name, $scope.user.mobilephone, $scope.user.postal, $scope.user.address, $scope.user.company, $scope.user.invoice);

                        } else {
                            $scope.isLoading = false;
                            $scope.isError = true;
                        }

                    }, function(error) {

                        if(error && error.code === 'error.account.mobilephoneRepeat'){
                            $scope.mobilephoneExistedError = true;
                        }

                        $scope.isLoading = false;
                        $scope.isError = true;
                    });
                } else {
                    addActivityLog($scope.user.email, $scope.user.name, $scope.user.mobilephone, $scope.user.postal, $scope.user.address, $scope.user.company, $scope.user.invoice);
                }
            }

            var addActivityLog = function(email, name, mobilephone, postal, address, company, invoice) {

                ActivityService.addActivityLog(email, name, mobilephone, postal, address, company, invoice).then(function(result) {
                    $scope.layoutType = 'SUCCESS';
                    $scope.isLoading = false;
                },function(error) {
                    $scope.isLoading = false;
                    $scope.isError = true;
                })
            }

            var openModal = function() {

                $ngModal.openModal('activity-apply-modal');
            }

            var closeModal = function() {
                $ngModal.closeModal('activity-apply-modal');
            }

            var cancel = function() {

                closeModal();
                $state.go('home');
            }

            var init20160701 = function() {

                var now = new Date();
                var openday = new Date('2016/08/01 00:00');
                var opentime = openday.getTime();
                $scope.isActivityEnd = false;

                if(now - opentime >= 0) {
                    $scope.isActivityEnd = true;
                    openModal();
                } else {
                    UserService.getUserInfo().then(function(result) {

                        if(result) {
                            $scope.user = result;
                            $scope.oriuser = shallowCopy(result);
                            openModal();
                        }
                    });
                }
            }

            var init20160801 = function() {

                var now = new Date();
                var openday = new Date('2016/09/01 00:00');
                var opentime = openday.getTime();
                $scope.isActivityEnd = false;

                if(now - opentime >= 0) {
                    $scope.isActivityEnd = true;
                    openModal();
                } else {
                    UserService.getUserInfo().then(function(result) {

                        if(result) {
                            $scope.user = result;
                            $scope.oriuser = shallowCopy(result);
                            openModal();
                        }
                    });
                }
            }

            var init = function() {

                if(!$scope.date) {
                    init20160701();
                }

                switch($scope.date) {
                    case '20160801':
                        return init20160801();
                    default:
                        return cancel();
                }
            }

            /*==========================
                Events
            ==========================*/
            $scope.$on("OPEN_ACTIVITY_APPLY_MODAL", function(event, data) {

                if(data) {
                    $scope.date = data.date;
                }

                $scope.layoutType = 'APPLY';

                init();
            });
                
            /*==========================
                Members
            ==========================*/
            $scope.layoutType = 'APPLY';
            $scope.user;
            $scope.oriuser;
            $scope.isUserNameEmpty = false;
            $scope.isUserMobilePhoneEmpty = false;
            $scope.isUserMobilePhoneError = false;
            $scope.isUserAddressEmpty = false;
            $scope.isUserPostalEmpty = false;
            $scope.isUserPostalError = false;
            $scope.isUserInvoiceError = false;
            $scope.isUserCompanyEmpty = false;
            $scope.isUserInvoiceEmpty = false;
            $scope.isParamsMissing = false;
            $scope.isParamsError = false;
            $scope.userInfoIsChange = false;
            $scope.mobilephoneExistedError = false;
            $scope.isActivityEnd = false;
            $scope.date;

            /*==========================
                Methods
            ==========================*/
            $scope.submit = submit;
            $scope.cancel = cancel;

            /*==========================
                init
            ==========================*/

        }]

        _dir.restrict = 'E';
        _dir.scope = true;
        _dir.templateUrl = 'partials/modal/activity_apply.html';
        _dir.controller = controller;

        return _dir;
}]);